// IMPORTANT: Polyfills must be initialized before ANY other imports to ensure they are applied globally
import './utils/polyfills';

import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// eslint-disable-next-line import/no-extraneous-dependencies -- dev-only overlay, tree-shaken out of prod builds (ADR-0014)
import { Agentation } from 'agentation';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import './bozic.css';
import store from './ducks/store';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { invariant } from './utils/invariant';

const container = document.getElementById('root');
invariant(container, 'Root element #root not found');

const root = createRoot(container);
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } }
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        {/* raw DEV literal (not getConfig) so the import is tree-shaken from prod builds — ADR-0014 */}
        {import.meta.env.DEV && <Agentation />}
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
